import BaseCaptchaField from 'registration/js/base/fields/captcha';

import template from 'registration/templates/new/fields/captcha.html';

const CaptchaField = BaseCaptchaField.extend({ template });

export default CaptchaField;
